document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.podcast-transcript').forEach(function(transcript) {
        const toggle = transcript.querySelector('.podcast-transcript__toggle');
        const text = transcript.querySelector('.podcast-transcript__text');

        if (!toggle || !text) {
            return;
        }

        function setExpanded(expanded) {
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            toggle.setAttribute('aria-label', expanded ? 'Hide transcript' : 'Show transcript');
            if (expanded) {
                text.removeAttribute('hidden');
            } else {
                text.setAttribute('hidden', 'until-found');
            }
        }

        toggle.addEventListener('click', function() {
            setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
        });

        // Find-in-page reveals hidden="until-found" content; keep the button in sync.
        text.addEventListener('beforematch', function() {
            setExpanded(true);
        });
    });
});
